import useMountain from './useMountain';

export default useMountain;
